
import React from "react";
import logo from "../pages/assets/trustauto-logo.png";            // your site logo
import illustration from "../pages/assets/illustration.svg"; // illustration image
import four04 from "../pages/assets/404.svg";           // 404 image
import callIcon from "../pages/assets/call.svg";  
import "./404.css"     

export default function NotFoundErrorPage() {
  return (
    <div className="error4">
    <div className="page-container">
      {/* Header */}
      <header className="header">
        <img src={logo} alt="Logo" className="logo" />
        <a href="tel:+1234567890" className="call-btn">
          <img src={callIcon} alt="Call" className="call-icon" />
          Click to Call
        </a>
      </header>

      {/* Main Content */}
      <main className="content">
        {/* Left illustration for desktop */}
        <div className="left">
          <img src={illustration} alt="Illustration" className="illustration" />
        </div>

        {/* Right content */}
        <div className="right">
          {/* Mobile illustration goes ABOVE the 404 content */}
          <div className="mobile-illustration">
            <img src={illustration} alt="Illustration" />
          </div>

          <img src={four04} alt="404" className="four04" />
          <h2>OOPS! Page Not Found!</h2>
          <p>The page you’ve been looking for is not available or does not exist</p>
          <a href="/" className="home-btn">Back to Home</a>
        </div>
      </main>
    </div>
    </div>
  );
}










